import { Copy } from '@phosphor-icons/react/dist/ssr';
import { toast } from 'react-toastify';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './CopyAPIKeyField.module.scss';

interface CopyAPIKeyFieldProps {
  text: string;
  withCopyButton?: boolean;
}

export const CopyAPIKeyField = ({
  text,
  withCopyButton = true,
}: CopyAPIKeyFieldProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard');
  };

  return (
    <div className={styles.root}>
      <p className={styles.key}>{text}</p>

      {withCopyButton && (
        <Button color="transparent" onClick={handleCopy}>
          <Copy size={SVG_SIZE_M} />
        </Button>
      )}
    </div>
  );
};
